// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/core-js/library/modules/_to-object.js
// module id = pk59
// module chunks = 6